import { useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../api.js'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      await api.auth.forgotPassword(email)
      setSent(true)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--app-bg)] px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <span className="text-5xl">🏆</span>
          <h1 className="mt-3 text-2xl font-bold text-gray-900 dark:text-slate-100">Grannäventyret</h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-slate-400">Återställ ditt lösenord</p>
        </div>

        <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm dark:border-slate-800 dark:bg-slate-900">
          {sent ? (
            <div className="text-center">
              <div className="mb-3 text-4xl">📬</div>
              <h2 className="mb-2 font-semibold text-gray-800 dark:text-slate-100">Kolla din inkorg</h2>
              <p className="mb-4 text-sm text-gray-500 dark:text-slate-400">
                Om <strong>{email}</strong> finns registrerat har vi skickat en återställningslänk. Länken är giltig i 1 timme.
              </p>
              <p className="text-xs text-gray-400 dark:text-slate-500">Kom ihåg att kolla skräpposten.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700 dark:text-slate-300">
                  E-postadress
                </label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="din@epost.se"
                  className="w-full rounded-xl border border-gray-300 bg-white px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100"
                />
              </div>
              {error && (
                <p className="rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-600 dark:border-red-400/20 dark:bg-red-500/10 dark:text-red-300">
                  {error}
                </p>
              )}
              <button
                type="submit"
                disabled={loading}
                className="w-full rounded-xl bg-indigo-600 py-2.5 font-semibold text-white hover:bg-indigo-700 disabled:opacity-50 dark:bg-sky-500 dark:text-slate-950"
              >
                {loading ? 'Skickar...' : 'Skicka återställningslänk'}
              </button>
            </form>
          )}
        </div>

        <p className="mt-4 text-center text-sm text-gray-500 dark:text-slate-400">
          <Link to="/login" className="font-medium text-indigo-600 hover:underline dark:text-sky-400">
            ← Tillbaka till inloggning
          </Link>
        </p>
      </div>
    </div>
  )
}
